module.exports = __webpack_public_path__ + "static/fonts/Inter-Bold.275bfea5.ttf";